import type {AddComponentTypeOptions} from 'grapesjs';
import {FORM_ERROR_MESSAGE_CONTAINER_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_ERROR_MESSAGE_CONTAINER_TYPE = 'postermywall-error-message-container';
const DATA_ATTR = 'data-is-pmw-error-message-container';

export const POSTERMYWALL_ERROR_MESSAGE_CONTAINER: AddComponentTypeOptions = {
  isComponent: (el: HTMLElement) => {
    if (typeof el.getAttribute !== 'function') {
      return undefined;
    }
    return el.tagName === 'DIV' && el.getAttribute(DATA_ATTR) !== null ? {type: POSTERMYWALL_ERROR_MESSAGE_CONTAINER_TYPE} : undefined;
  },
  model: {
    defaults: {
      tagName: 'div',
      toolbar: [],
      copyable: false,
      draggable: false,
      droppable: false,
      hoverable: false,
      selectable: false,
      highlightable: false,
      badgable: false,
      style: FORM_ERROR_MESSAGE_CONTAINER_STYLES,
      attributes: {
        [DATA_ATTR]: '1',
        id: POSTERMYWALL_ERROR_MESSAGE_CONTAINER_TYPE,
      },
    },
  },
};
